import api from './container';
import { handleMessages, load } from './util';
import { KEYCODES } from './util/keycodes';

$(document).on('submit.copyCartPositions', '[data-copy-shoppinglist-cart-positions]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const data = $form.serializeArray();
  load(
    this,
    $.stores.shoppinglist.post($form.attr('action'), data),
  );
});

$(document).on('submit.removeCartPositions', '[data-remove-shoppinglist-positions]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-container-position-editmode]:checked').each((idx, input) => {
    data.push({ name: 'position_id', value: input.value });
  });

  load(
    this,
    $.stores.shoppinglist.post($form.attr('action'), data),
  ).then((result) => {
    if (result.container.position_count === 0) {
      $(this).closest('.position-container').removeClass('position-container--editmode');
      $('[data-container-editmode]').addClass('hide');
    }
  });
});

$(document).on('submit', '[data-add-to-shopping-list]', function (event) {
  event.preventDefault();
  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data: $(this).serialize(),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-add-positions-to-shopping-list]', function (event) {
  event.preventDefault();
  const formData = $(this).serializeArray();
  $('[data-container-position-editmode]:checked').each((idx, input) => {
    formData.push({ name: 'position_id', value: input.value });
  });

  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data: formData,
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-add-to-shopping-list-form]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serialize(),
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit', '[data-add-shoppinglist-position]', function(event) {
  event.preventDefault();

  let qty = $(this).find('[data-add-shoppinglist-position-quantity]').first();
  if (qty.length === 0) {
    qty = $(this).find('input[name="quantity"]').first();
  }

  const $form = qty.closest('form');
  const isConfiguration = $form.attr('data-item-configuration');
  if (isConfiguration) {
    const $itemId = $form.find('input[name="item_id"]');
    const $configurationForm = $itemId && $(`[data-item-configuration-form="${$itemId.val()}"]`);
    if ($configurationForm.length > 0) {
      const excludes = ['csrfmiddlewaretoken', 'quantity'];
      const data = $form.serializeArray();
      $configurationForm.serializeArray().filter(param => !excludes.includes(param.name))
        .forEach(param => data.push(param));

      const promise = $.ajax({
        url: isConfiguration,
        method: 'POST',
        data,
      }).then(handleMessages);

      load($form.closest('[data-reveal]'), promise, {
        errorClass: 'error',
      });
    }
  } else {
    api.updateQuantity(qty, 'shoppinglist', true);
  }
});

$(document).on('submit', '[data-update-shoppinglist-position]', event => event.preventDefault());

$(document).on('keydown', '[data-update-shoppinglist-position-quantity]', function(event) {
  if (event.which === KEYCODES.ENTER) {
    api.updateQuantity($(this), 'shoppinglist');
  }
});

$(document).on('keyup', '[data-update-shoppinglist-position-quantity]', function() {
  $(this).closest('form')[this.value !== this.defaultValue ? 'addClass' : 'removeClass']('ready');
});

$(document).on('blur', '[data-update-shoppinglist-position-quantity]', function() {
  api.updateQuantity($(this), 'shoppinglist');
});

$(document).on('input', '[data-update-shoppinglist-position-quantity]', function() {
  $(this).closest('[data-cart-item]').find('[data-add-cart-position] input[name="quantity"]').val($(this).val());
});

$(document).on('submit', '[data-update-shoppinglist-position-text]', event => event.preventDefault());
$(document).on('change', '[data-update-shoppinglist-position-text]', function(event) {
  event.preventDefault();
  api.setPositionText($(this), 'shoppinglist');
});

$(document).on('submit', '[data-remove-shoppinglist-position]', function(event) {
  event.preventDefault();
  api.removePosition($(this), 'shoppinglist');
});

$(document).on('click', '[data-update-shoppinglist]', function(event) {
  event.preventDefault();
  api.showUpdateReveal($(this));
});

$(document).on('submit', '[data-shoppinglist-update-form]', function(event) {
  event.preventDefault();
  api.updateContainer($(this).closest('form'), 'shoppinglist');
});

$(document).on('submit', '[data-copy-shoppinglist-positions]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serializeArray(),
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit', '[data-create-and-add-to-shoppinglist-form]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');
  const formData = $form.serializeArray();
  let action = $form.attr('action');

  const isConfiguration = $form.attr('data-item-configuration');
  if (isConfiguration) {
    action = isConfiguration;
    const $itemId = $form.find('input[name="item_id"]');
    const $configurationForm = $itemId && $(`[data-item-configuration-form="${$itemId.val()}"]`);
    if ($configurationForm.length > 0) {
      const excludes = ['csrfmiddlewaretoken', 'quantity'];
      $configurationForm.serializeArray().filter(param => !excludes.includes(param.name))
        .forEach(param => formData.push(param));
    }
  }

  if ($form.find('input[name="label"]').length === 0) {
    const label = $form.closest('[data-table-oninput]').find('[data-table-search-query]').text();
    formData.push({ name: 'label', value: label });
  }

  const promise = $.ajax({
    url: action,
    method: 'POST',
    data: formData,
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit', '[data-shoppinglist-import]', function(event) {
  event.preventDefault();
  api.importPositions($(this), 'shoppinglist');
});

$(document).on('closeme.zf.reveal', '[data-shoppinglist-import]', function() {
  this.reset();
  $(this).removeClass('error');
  $(this).find('[data-shoppinglist-import-messages]').html('').hide()
    .removeClass('alert');
});

$(document).on('click', '[data-change-shoppinglist-position-reel]', function(event) {
  event.preventDefault();
  api.changePositionReel($(this), 'shoppinglist');
});

$(document).on('submit', '[data-update-shoppinglist-position-reel]', function(event) {
  event.preventDefault();
  api.updatePositionReel($(this), 'shoppinglist');
});

$(document).on('change', '[data-shoppinglist-positions-ordering]', function(event) {
  event.preventDefault();
  $(this).submit();
});

$(document).on('click', 'button[data-shoppinglist-checkout-details-reveal]', function (event) {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(this).attr('data-shoppinglist-checkout-details-reveal'),
  }).done((resp) => {
    const $reveal = $(this).closest('[data-reveal]');
    if ($reveal.length) {
      $reveal.foundation('close');
    }
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', 'form[data-shoppinglist-checkout-details-reveal]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  $reveal.addClass('loading');

  return load($reveal, $.stores.shoppinglist.post($form.attr('action'), $form.serializeArray()).then((response) => {
    if (!response.status) {
      $reveal.foundation('close');
      $reveal.replaceWith(response.html).foundation();
    } else {
      setTimeout(() => $reveal.foundation('close'), 1500);
    }
  }));
});

$(document).on('click', 'form[data-shoppinglist-checkout-details-reset]', function(event) {
  event.preventDefault();
  const $form = $(this);
  return load($form, $.stores.shoppinglist.post($form.attr('action'), $form.serializeArray()));
});
